import { useState, useEffect, useRef, useContext, useMemo } from "react";
import {
  IconButton,
  Drawer,
  SwipeableDrawer,
  List,
  ListItemButton,
  ListItemText,
  Tooltip,
  Box,
  useTheme,
  useMediaQuery,
  Backdrop,
  Collapse,
  Typography,
} from "@mui/material";
import {
  Dashboard,
  GroupAddOutlined,
  Description,
  Campaign,
  Assessment,
  Message,
  ChevronLeft,
  ChevronRight,
  ExpandMore,
  ExpandLess,
  ManageAccountsOutlined,
} from "@mui/icons-material";
import CallIcon from "@mui/icons-material/Call";
import { Route, Routes, useNavigate } from "react-router-dom";
import AppBarComponent from "../widgets/AppBarComponent";
import DashboardLayout from "./DashboardLayout";
import CreateSubmitTemplate from "./templates/CreateSubmitTemplate";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import PermMediaOutlinedIcon from "@mui/icons-material/PermMediaOutlined";
import MediaLibrary from "./media/MediaLibrary";
import MyTemplates from "./templates/MyTemplates";
import JsonPrettifier from "./templates/ReactJsonView";
import TemplateDetails from "./templates/TemplateDetails";
import MainCampaign from "./campaign/MainCampaign";
import { UserContext } from "../context/UserProvider";
import { FaImage } from "react-icons/fa";
import MuPb from "../widgets/MuPb";
import ManageAccounts from "./ManageAccounts";
import TrackMyCampaign from "./campaign/TrackMyCampaign";
import MyCampaignChats from "./campaign/MyCampaignChats";
import Chats from "./chats/Chats";
import ApiSettings from "./profile/ApiSettings";
import CampaignApiDoc from "./profile/CampaignApiDoc";
import SessionApiDocs from "./profile/SessionApiDocs";
import ChainReplyBuilder from "./autoreply/ChainReplyBuilder";
import AddMessages from "./autoreply/addbots/AddMessages";
import AutoReplyBuilder from "./autoreply/AutoReplyBuilder";
import ChatbotList from "./autoreply/ChatbotList";
import UploadAudio from "./media/UploadAudio";
import AccountsList from "./accounts/AccountsList";
import AddAccount from "./accounts/AddAccount";
import AccountDetails from "./accounts/AccountDetails";
import UsersList from "./accounts/UsersList";
import AddUser from "./accounts/AddUser";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import DataTableWithExport from "./campaign/DataTableWithExport";
import AccountProfile from "./auths/AccountProfile";
import ContactGroupForm from "./contacts/ContactsGroupForm";
import ContactsList from "./contacts/ContactsList";
import ContactDetail from "./contacts/ContactDetail";
import AddContactToGroup from "./contacts/AddContactToGroup";
import ChatBotDetail from "./autoreply/ChatBotDetail";
import SubscriptionPlans from "./subscriptions/SubscriptionPlans";
import EditAccount from "./accounts/EditAccount";
import PricingEditor from "./settings/PricingEditor";
import TransactionHistory from "./transactions/TransactionHistory";
import AddCredit from "./transactions/AddCredit";
import AddPlan from "./transactions/AddPlan";
import PricingUpdateForm from "./settings/PricingUpdateForm";
import AddUserManually from "./accounts/AddUserManually";
import EditMessages from "./autoreply/EditMessage";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import BusinessList from "./partners/BusinessList";
import BusinessDetail from "./partners/BusinessDetail";
import EditBusiness from "./partners/EditBusiness";
import ProjectsList from "./partners/ProjectsList";
import ProjectDetail from "./partners/ProjectDetail";
import CreateBusiness from "./partners/CreateBuinsess";
import CreateProject from "./partners/CreateProject";
import LinkProjectToAccount from "./partners/LinkProjectToAccount";
import AccountLink from "./accounts/AccountLink";
import FlowsList from "./formsflow/FlowsList";
import CreditOverview from "./credits/CreditOverview";
import CreditHistory from "./credits/CreditHistory";
import FlowDetails from "./formsflow/FlowDetails";
import CreateFlow from "./formsflow/CreateFlow";
import FlowJsonEditor from "./formsflow/FlowJsonEditor";
import FlowForms from "./formsflow/FlowForms";
import RdCampaign from "./campaign/RdCampaign";
import RdCampaignsList from "./campaign/RdCampaignsList";
import { useDialog } from "../context/DialogContext";
import { CommonDialog } from "./CommonDialog";
import TemplateStatusChecker from "./templates/TemplateStatusChecker";
import ChatbotFlowsList from "./autoreply/flows/FlowsList";
import AddChatbotFlow from "./autoreply/flows/AddChatbotFlow";
import StorageIcon from "@mui/icons-material/Storage";
import RechargeComponent from "./payments/RechargeComponent";
import ZohoAuth from "./payments/ZohoAuth";
import ContactDatabase from "./database/ContactDatabase";
import ChatbotFlowDetails from "./autoreply/flows/ChatbotFlowDetails";
import CategoryManager from "./database/CategoryManager";
import AssignUser from "./database/AssignUser";
import HelpFeedbackForm from "./accounts/HelpSupport";
import AllRdCampaignList from "./campaign/AllRdCampaignList";
import RdCampaignDetail from "./campaign/RdCampaignDetail";
import RdMyCampaignLive from "./campaign/RdMyCampaignLive";
import RdMessageDetail from "./campaign/RdMessageDetail";
import SubscriptionPlanStats from "./accounts/SubscriptionPlanStats";
import SubscriptionAccounts from "./accounts/SubscriptionAccounts";
import AccountUsageDetails from "./accounts/AccountUsageDetails";
import DatabaseAnalysis from "./database/analysis/DatabaseAnalysis";
import TextFieldTest from "./TextFieldTest";
import LeadsStats from "../leads/LeadsStats";
import TemplatesUsed from "./accounts/TemplatesUsed";
import FlowsReport from "./flowbuilder/FlowsReport";
import TemplateCreatorRaw from "./formsflow/TemplateCreatorRaw";
import RawSendMessage from "./formsflow/RawSendMessage";
import WhatsAppCarouselCreator from "./templates/WhatsAppCarouselCreator";
import CampaignCreatorPrompt from "../ai/CampaignCreatorPrompt";
import { CommonInputDialog } from "./CommonInputDialog";
import { CommonAiOptions } from "./CommonAiOptions";
import ExampleUsage from "../ai/ExampleUsage";
import RcsPanel from "./rcs/RcsPanel";
import RcsAddTemplate from "../ai/RcsAddTemplate";
import ImageSelectionModal from "../widgets/MediaSelectionModal";
import RcsCampaignBuilder from "../ai/RcsCampaignBuilder";
import RcsCampaignLauncher from "./rcs/RcsCampaignLauncher";
import RcsTemplates from "./rcs/RcsTemplates";
import WabaCarouselTemplate from "./templates/WabaCarouselTemplate";
import CreditRecharge from "./transactions/CreditRecharge";
import MainDash from "./MainDash";
import WabaQualityGuide from "./pages/WabaQualityGuide";
import AdminRcsTemplates from "./rcs/AdminRcsTemplates";
import AdminRcsTemplateDetail from "./rcs/AdminRcsTemplateDetail";
import RequestCredits from "./pages/RequestCredits";
import PromptPreviewer from "./pages/PromptPreviewer";
import DbColumnsManager from "./database/newdb/DbColumnsManager";
import DatabaseManager from "./database/newdb/DatabaseManager";
import AddItemForm from "./database/newdb/AddItemForm";
import UserResponses from "./rcs/UserResponses";
import CampaignAiTable from "./pages/CampaignAiTable";
import AccountGroupsManage from "./accounts/AccountGroupsManage";
import ResellersList from "./accounts/ResellersList";
import AddReseller from "./accounts/AddReseller";
import CreditUsageHistory from "./CreditUsageHistory";
import ResellerDetail from "./reseller/ResellerDetail";
import MessageDebugDetail from "./accounts/MessageDebugDetail";
import AccountSetLimit from "./accounts/AccountSetLimit";
import PricingPlansManager from "./accounts/PricingPlansManager";
import VoiceDashboard from "./voice/VoiceDashboard";
import RCSFormGenerator from "../ai/RcsFormGenerator";
import Rcs2CampaignLauncher from "./rcs/Rcs2CampaignLauncher";
import VoiceFileUpload from "./voice/VoiceFileUpload";
import VoiceFilesList from "./voice/VoiceFilesList";
import VoiceCampaigns from "./voice/VoiceCampaigns";
import LaunchVoiceCampaign from "./voice/LaunchVoiceCampaign";
import VoiceFileDetails from "./voice/VoiceFileDetails";
import AllVoiceFilesList from "./voice/AllVoiceFilesList";
import UploadContactsForm from "./voice/UploadContactsCsv";
import ReportDashboard from "./voice/VoiceReports";
import LiveVoiceReport from "./voice/LiveVoiceReport";
import DownloadReports from "./voice/DownloadReports";
import ScheduledCampaignsList from "./voice/ScheduledCampaignsList";
import RcsJioTemplates from "./rcs/RcsJioTemplates";
import MediaItems from "./media/MediaItems";
import VoiceFallback from "./voice/VoiceFallback";
import VoiceTransactonHistory from "./voice/VoiceTransactonHistory";
import VoiceFullReports from "./voice/VoiceFullReports";
import UsageHistoryRcs from "./transactions/UsageHistoryRcs";
import SheetSchemaBuilder from "./profile/SheetsSchemaBuilder";
import GroupedTemplates from "./templates/GroupedTemplates";
import SubAccountsList from "./accounts/SubAccountsList";
import SheetSchemaList from "./profile/SheetSchemaList";
import SheetSchemaEdit from "./profile/SheetSchemaEdit";

const drawerWidth = 240;
const collapsedWidth = 72;

// Color palette for icons and accents
const iconColors = {
  dashboard: "#4f46e5", // Indigo
  settings: "#059669", // Emerald
  templates: "#dc2626", // Red
  media: "#ea580c", // Orange
  rcs: "#7c3aed", // Violet
  chatbot: "#0891b2", // Cyan
  campaign: "#db2777", // Pink
  reports: "#ca8a04", // Yellow
  chats: "#16a34a", // Green
  flows: "#9333ea", // Purple
  database: "#0369a1", // Blue
  partners: "#c2410c", // Amber
  accounts: "#be123c", // Rose
  credit: "#0d9488", // Teal
};

const HomeDash = () => {
  const { dialog, hideDialog, hideInputDialog, hideAiDialog, hideMediaDialog } =
    useDialog();
  const navigate = useNavigate();
  const { user, loading } = useContext(UserContext);
  const [open, setOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const drawerRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [openSubMenus, setOpenSubMenus] = useState({});

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setOpen((prev) => !prev);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const toggleButton = document.querySelector(".menu-toggle-button");
      if (toggleButton?.contains(event.target)) return;
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        if (!isMobile && open) setOpen(false);
        if (isMobile && mobileOpen) setMobileOpen(false);
      }
    };

    if (mobileOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, mobileOpen, isMobile]);

  const handleNavigation = (link) => {
    navigate(link);
    if (isMobile) setMobileOpen(false);
  };

  const handleSubMenuToggle = (menuText) => {
    if (!open && !isMobile) setOpen(true);
    setOpenSubMenus((prev) => ({
      ...prev,
      [menuText]: !prev[menuText],
    }));
  };

  const getIconColor = (menuKey) => {
    return iconColors[menuKey] || "#4f46e5"; // Default to indigo
  };

  const getColoredIcon = (icon, menuKey) => {
    return (
      <Box
        sx={{
          color: getIconColor(menuKey),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </Box>
    );
  };

  const menus = useMemo(() => {
    const baseMenuItems = [
      {
        text: "Dashboard",
        link: "/home/dashboard",
        icon: <Dashboard />,
        key: "dashboard",
      },
      {
        text: "Contacts List",
        link: "/home/configurations/contacts",
        icon: <GroupAddOutlined />,
        key: "settings",
        //subItems: [
        // { text: "Users", link: "/home/configurations/users" },
        // { text: "Contacts", link: "/home/configurations/contacts" },
        // { text: "Manage Chatbot(s)", link: "/home/chatbots" },
        // { text: "Catalogs", link: "/home/configurations/catalogs" },
        // { text: "Manage Tag", link: "/home/configurations/manage-tag" },
        // ],
      },
      {
        text: "ChatBot Builder",
        link: "/home/chatbots",
        icon: <SmartToyOutlinedIcon />,
        key: "chatbot",
      },
      {
        text: "Templates",
        link: "/home/templates",
        icon: <Description />,
        key: "templates",
      },
      {
        text: "Campaign",
        link: "/campaign",
        icon: <Campaign />,
        key: "campaign",
        subItems: [
          { text: "Send Campaign", link: "/home/campaign" },
          { text: "Queue Monitor", link: "/home/queue-monitor" },
          ...(user?.userType === "SuperAdmin" || user?.userType === "Root"
            ? [
                { text: "All Queue Monitor", link: "/home/all-queues-monitor" },
                { text: "Credit Usage All", link: "/home/usage-history" },
              ]
            : []),
        ],
      },

      {
        text: "Media Library",
        link: "/home/media-library",
        icon: <PermMediaOutlinedIcon />,
        key: "media",
      },
      {
        text: "Voice Call",
        link: "/home/voice-dashboard",
        icon: <CallIcon />,
        subItems: [
          { text: "Dashboard", link: "/home/voice-dashboard" },
          { text: "Voice files", link: "/home/voice-files" },
          // { text: "Campaigns", link: "/home/voice-campaigns" },
          { text: "Launch Campaign", link: "/home/launch-voice-campaign" },
          { text: "Live Campaign report", link: "/home/live-voice-report" },
          { text: "Main Report", link: "/home/voice-reports-view" },
          {
            text: "Scheduled Campaigns",
            link: "/home/scheduled-voice-campaigns",
          },
          { text: "Reports", link: "/home/voice-campaign-reports" },
          { text: "Fallback Reports", link: "/home/voice-fallback-reports" },
          { text: "Download Reports", link: "/home/voice-download-reports" },
          // { text: "Contacts List", link: "/home/upload-contacts-csv" },
          { text: "Transaction History", link: "/home/voice-history" },
          ...(user?.userType === "SuperAdmin" || user?.userType === "Root"
            ? [{ text: "All Voice files", link: "/home/all-voice-files" }]
            : []),
        ],
      },
      {
        text: "RCS",
        link: "/home/rcs-dashboard",
        icon: <FaImage />,
        key: "rcs",
        subItems: [
          { text: "Dashboard", link: "/home/rcs-dashboard" },
          // ✅ Partner-based menu
          ...(user?.rcsPartner === "jio"
            ? [
                { text: "Create template", link: "/home/rcs-add-template" },
                { text: "Send Campaign", link: "/home/rcs-campaign" },
                { text: "Templates", link: "/home/rcs1-templates" },
              ]
            : [
                { text: "Create template", link: "/home/rcs2-add-template" },
                { text: "Send Campaign", link: "/home/rcs2-campaign" },
                { text: "Templates", link: "/home/rcs-templates" },
              ]),

          { text: "User Responses", link: "/home/user-responses" },
          { text: "Queue Monitor", link: "/home/queue-monitor?type=rcs" },

          // ✅ Role-based menu
          ...(user?.userType === "Root" || user?.userType === "SuperAdmin"
            ? [
                {
                  text: "All Users Templates",
                  link: "/home/all-users-templates",
                },
                {
                  text: "All Queue Monitor",
                  link: "/home/all-queues-monitor?type=rcs",
                },
              ]
            : []),
        ],
      },
      {
        text: "Reports",
        link: "/reports",
        icon: <Assessment />,
        key: "reports",
        subItems: [
          { text: "Campaign Report", link: "/home/my-campaigns" },
          { text: "Flow Responses", link: "/home/flows-reports" },
        ],
      },
      {
        text: "Chats",
        link: "/home/chats",
        icon: <Message />,
        key: "chats",
      },
      {
        text: "Flows",
        link: "/home/flows",
        icon: <AccountTreeIcon />,
        key: "flows",
      },
      {
        text: "Database",
        link: "/home/database",
        icon: <StorageIcon />,
        key: "database",
      },
    ];
    if (!user) return baseMenuItems;
    const roleBasedMenuItems = [
      ...(user.userType === "Root" || user.userType === "SuperAdmin"
        ? [
            // {
            //   text: "Partner Solutions",
            //   link: "/home/partners",
            //   icon: <HandshakeIcon />,
            //   key: "partners",
            //   subItems: [
            //     { text: "Businesses", link: "/home/business-list" },
            //     { text: "Link Project", link: "/home/link-project-to-waba" },
            //   ],
            // },
            {
              text: "Manage Accounts",
              link: "/home/manage-accounts",
              icon: <ManageAccountsOutlined />,
              key: "accounts",
              subItems: [
                { text: "Update Pricing", link: "/home/pricing-editor" },
                { text: "Manage Plans", link: "/home/manage-plans" },
                { text: "Accounts List", link: "/home/accounts-list" },
              ],
            },
          ]
        : []),
      ...(user.userType === "SuperAdmin" || user.userType === "Credit"
        ? [
            {
              text: "Manage Credit",
              link: "/home/credits",
              icon: <BusinessCenterOutlinedIcon />,
              key: "credit",
              subItems: [
                { text: "Credits Overview", link: "/home/credits" },
                { text: "Recharge History", link: "/home/credit-history" },
                { text: "RCS Usage", link: "/home/rcs-usage-history" },
              ],
            },
          ]
        : []),
    ];
    return [...baseMenuItems, ...roleBasedMenuItems];
  }, [user]);

  if (loading) {
    return <MuPb />;
  }

  const drawerContent = (
    <Box
      ref={drawerRef}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background:
          "linear-gradient(135deg, #ffffff 0%, #f8fafc 50%, #f1f5f9 100%)",
        color: "#334155",
        boxShadow: `
          0 8px 32px rgba(0, 0, 0, 0.1),
          inset 0 1px 0 rgba(255, 255, 255, 0.8),
          inset 0 -1px 0 rgba(0, 0, 0, 0.05)
        `,
        backdropFilter: "blur(20px)",
        borderRight: "1px solid rgba(255, 255, 255, 0.3)",
        transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
        overflow: "hidden",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: open ? "space-between" : "center",
          p: 2,
          borderBottom: "1px solid rgba(148, 163, 184, 0.1)",
          minHeight: 64,
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(248,250,252,0.8) 100%)",
          backdropFilter: "blur(10px)",
          boxShadow: "0 2px 20px rgba(0, 0, 0, 0.05)",
        }}
      >
        {open && !isMobile && (
          <Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                letterSpacing: "0.5px",
                background:
                  "linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #c026d3 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                fontSize: "1.25rem",
              }}
            >
              AI Growth
            </Typography>
          </Box>
        )}
        <IconButton
          onClick={handleDrawerToggle}
          aria-label="toggle drawer"
          className="menu-toggle-button"
          sx={{
            color: "#64748b",
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(248,250,252,0.8) 100%)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.5)",
            boxShadow: `
              0 4px 12px rgba(0, 0, 0, 0.05),
              inset 0 1px 0 rgba(255, 255, 255, 0.8)
            `,
            "&:hover": {
              background:
                "linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(248,250,252,0.9) 100%)",
              transform: "translateY(-1px)",
              boxShadow: `
                0 6px 20px rgba(0, 0, 0, 0.1),
                inset 0 1px 0 rgba(255, 255, 255, 0.9)
              `,
            },
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          {isMobile || !open ? <ChevronRight /> : <ChevronLeft />}
        </IconButton>
      </Box>

      {/* Menu Items */}
      <List
        sx={{
          p: 1.5,
          flexGrow: 1,
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "linear-gradient(135deg, #c7d2fe 0%, #a5b4fc 100%)",
            borderRadius: "10px",
            border: "2px solid transparent",
            backgroundClip: "padding-box",
          },
          "&::-webkit-scrollbar-track": {
            background: "rgba(203, 213, 225, 0.2)",
            borderRadius: "10px",
          },
        }}
      >
        {menus?.map((item) => (
          <Box key={item.text} sx={{ mb: 0.5 }}>
            <Tooltip
              title={!isMobile && !open ? item.text : ""}
              placement="right"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "white",
                    color: "#334155",
                    border: "1px solid rgba(226, 232, 240, 0.8)",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
                    backdropFilter: "blur(10px)",
                    borderRadius: "8px",
                  },
                },
              }}
            >
              <ListItemButton
                onClick={() =>
                  item.subItems
                    ? handleSubMenuToggle(item.text)
                    : handleNavigation(item.link)
                }
                sx={{
                  borderRadius: "12px",
                  mb: 0.5,
                  px: 2,
                  py: 1.2,
                  justifyContent: open || isMobile ? "flex-start" : "center",
                  background:
                    item.subItems && openSubMenus[item.text]
                      ? `linear-gradient(135deg, ${getIconColor(
                          item.key
                        )}15 0%, ${getIconColor(item.key)}08 100%)`
                      : "transparent",
                  border: "1px solid transparent",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${getIconColor(
                      item.key
                    )}10 0%, ${getIconColor(item.key)}05 100%)`,
                    border: `1px solid ${getIconColor(item.key)}20`,
                    transform: "translateY(-1px)",
                    boxShadow: `
                      0 6px 20px ${getIconColor(item.key)}15,
                      inset 0 1px 0 rgba(255, 255, 255, 0.8)
                    `,
                  },
                  "&.Mui-selected": {
                    background: `linear-gradient(135deg, ${getIconColor(
                      item.key
                    )}15 0%, ${getIconColor(item.key)}08 100%)`,
                    border: `1px solid ${getIconColor(item.key)}30`,
                    boxShadow: `
                      0 4px 15px ${getIconColor(item.key)}15,
                      inset 0 1px 0 rgba(255, 255, 255, 0.6)
                    `,
                    "& .MuiTypography-root": {
                      fontWeight: 700,
                      color: getIconColor(item.key),
                    },
                  },
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
                selected={window.location.pathname === item.link}
                aria-expanded={
                  item.subItems ? openSubMenus[item.text] : undefined
                }
                aria-label={item.text}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    justifyContent:
                      open || isMobile ? "space-between" : "center",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        minWidth: 36,
                        height: 36,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: `linear-gradient(135deg, ${getIconColor(
                          item.key
                        )}20 0%, ${getIconColor(item.key)}10 100%)`,
                        borderRadius: "10px",
                        border: `1px solid ${getIconColor(item.key)}30`,
                        boxShadow: `
                          0 2px 8px ${getIconColor(item.key)}15,
                          inset 0 1px 0 rgba(255, 255, 255, 0.6)
                        `,
                        transition: "all 0.3s ease",
                      }}
                    >
                      {getColoredIcon(item.icon, item.key)}
                    </Box>
                    {(open || isMobile) && (
                      <ListItemText
                        primary={item.text}
                        primaryTypographyProps={{
                          variant: "body1",
                          fontWeight:
                            item.subItems && openSubMenus[item.text]
                              ? 700
                              : 600,
                          fontSize: "0.9rem",
                          letterSpacing: "0.2px",
                          color:
                            item.subItems && openSubMenus[item.text]
                              ? getIconColor(item.key)
                              : "#475569",
                        }}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </Box>
                  {(open || isMobile) && item.subItems && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: openSubMenus[item.text]
                          ? getIconColor(item.key)
                          : "#94a3b8",
                        transition: "color 0.2s ease",
                      }}
                    >
                      {openSubMenus[item.text] ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )}
                    </Box>
                  )}
                </Box>
              </ListItemButton>
            </Tooltip>

            {/* Submenu Section */}
            {item.subItems && (open || isMobile) && (
              <Collapse
                in={openSubMenus[item.text]}
                timeout="auto"
                unmountOnExit
                sx={{
                  background:
                    "linear-gradient(135deg, rgba(248, 250, 252, 0.8) 0%, rgba(241, 245, 249, 0.6) 100%)",
                  borderRadius: "0 0 12px 12px",
                  mt: -0.5,
                  borderLeft: `2px solid ${getIconColor(item.key)}30`,
                  backdropFilter: "blur(10px)",
                  boxShadow: "inset 0 2px 4px rgba(0,0,0,0.02)",
                }}
              >
                <List component="div" disablePadding>
                  {item.subItems.map((subItem) => (
                    <ListItemButton
                      key={subItem.text}
                      onClick={() => handleNavigation(subItem.link)}
                      sx={{
                        pl: 5,
                        borderRadius: "8px",
                        mb: 0.25,
                        py: 0.75,
                        mx: 1,
                        background: "transparent",
                        color:
                          window.location.pathname === subItem.link
                            ? getIconColor(item.key)
                            : "#64748b",
                        "&:hover": {
                          background: `linear-gradient(135deg, ${getIconColor(
                            item.key
                          )}10 0%, ${getIconColor(item.key)}05 100%)`,
                          color: getIconColor(item.key),
                          transform: "translateX(2px)",
                        },
                        "&.Mui-selected": {
                          background: `linear-gradient(135deg, ${getIconColor(
                            item.key
                          )}15 0%, ${getIconColor(item.key)}08 100%)`,
                          color: getIconColor(item.key),
                          fontWeight: 600,
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            top: "50%",
                            transform: "translateY(-50%)",
                            height: "60%",
                            width: "3px",
                            background: `linear-gradient(135deg, ${getIconColor(
                              item.key
                            )} 0%, ${getIconColor(item.key)}80 100%)`,
                            borderRadius: "0 2px 2px 0",
                          },
                        },
                        position: "relative",
                        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                        fontWeight:
                          window.location.pathname === subItem.link ? 600 : 400,
                      }}
                      selected={window.location.pathname === subItem.link}
                    >
                      <ListItemText
                        primary={subItem.text}
                        primaryTypographyProps={{
                          variant: "body2",
                          sx: {
                            fontSize: "0.8rem",
                            fontWeight: "inherit",
                            letterSpacing: "0.1px",
                          },
                        }}
                      />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            )}
          </Box>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBarComponent
        isMobile={isMobile}
        open={open}
        drawerWidth={drawerWidth}
        collapsedWidth={collapsedWidth}
        handleDrawerToggle={handleDrawerToggle}
      />
      {!isMobile && (
        <Drawer
          variant="permanent"
          sx={{
            width: open ? drawerWidth : collapsedWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: open ? drawerWidth : collapsedWidth,
              transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.standard,
              }),
              boxSizing: "border-box",
              position: "fixed",
              height: "100vh",
              overflowY: "hidden",
              border: "none",
              background: "transparent",
            },
          }}
        >
          {drawerContent}
        </Drawer>
      )}
      {isMobile && (
        <>
          <Backdrop
            open={mobileOpen}
            onClick={() => setMobileOpen(false)}
            sx={{
              zIndex: theme.zIndex.drawer - 1,
              bgcolor: "rgba(15, 23, 42, 0.4)",
              backdropFilter: "blur(4px)",
            }}
          />
          <SwipeableDrawer
            variant="temporary"
            open={mobileOpen}
            onClose={() => setMobileOpen(false)}
            onOpen={() => setMobileOpen(true)}
            ModalProps={{ keepMounted: true }}
            sx={{
              "& .MuiDrawer-paper": {
                width: drawerWidth,
                border: "none",
              },
            }}
          >
            {drawerContent}
          </SwipeableDrawer>
        </>
      )}

      <Box
        sx={{
          position: "fixed",
          top: "60px",
          right: 0,
          left: isMobile
            ? "0"
            : !open
            ? `${collapsedWidth}px`
            : `${drawerWidth}px`,
          maxHeight: "calc(100vh - 60px)",
          overflowY: "auto",
          background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
        }}
      >
        <CampaignCreatorPrompt />
        <Routes>
          <Route path=":dashboard?" element={<DashboardLayout />} />
          <Route path=":id/template-campaign" element={<MainCampaign />} />
          <Route path="templates" element={<MyTemplates />} />
          <Route path="campaign" element={<RdCampaign />} />
          <Route path=":id/reseller" element={<ResellerDetail />} />
          <Route path="waba-carousel" element={<WabaCarouselTemplate />} />
          <Route path="settings" element={<ApiSettings />} />
          <Route path="credit-history" element={<CreditHistory />} />
          <Route path="business-list" element={<BusinessList />} />
          <Route path=":id/business-detail" element={<BusinessDetail />} />
          <Route path=":id/edit-business" element={<EditBusiness />} />
          <Route path="create-business" element={<CreateBusiness />} />
          <Route path=":id/create-project" element={<CreateProject />} />
          <Route
            path="link-project-to-waba"
            element={<LinkProjectToAccount />}
          />
          <Route path="leads-stats" element={<LeadsStats />} />
          <Route path="media-items" element={<MediaItems />} />
          <Route path=":id/project-detail" element={<ProjectDetail />} />
          <Route path=":id/projects-list" element={<ProjectsList />} />
          <Route path="profile" element={<AccountProfile />} />
          <Route path="credits" element={<CreditOverview />} />
          <Route path=":id/recharge-area" element={<CreditRecharge />} />
          <Route path=":id/add-credit" element={<AddCredit />} />
          <Route path=":id/add-plan" element={<AddPlan />} />
          <Route path="update-plan-pricing" element={<PricingUpdateForm />} />
          <Route path="campaign-api-docs" element={<CampaignApiDoc />} />
          <Route path="session-api-docs" element={<SessionApiDocs />} />
          <Route path="auto-replies" element={<ChatbotList />} />
          <Route path="campaign" element={<RdCampaign />} />
          <Route path="queue-monitor" element={<RdCampaignsList />} />
          <Route path="all-queues-monitor" element={<AllRdCampaignList />} />
          <Route path="chain-reply-builder" element={<ChainReplyBuilder />} />
          <Route path="add-contact" element={<ContactGroupForm />} />
          <Route path="campaign-creator" element={<CampaignCreatorPrompt />} />
          <Route path="add-contact-list" element={<AddContactToGroup />} />
          <Route path="database-analysis" element={<DatabaseAnalysis />} />
          <Route
            path="subscription-plan-stats"
            element={<SubscriptionPlanStats />}
          />
          <Route
            path="subscription-accounts"
            element={<SubscriptionAccounts />}
          />
          <Route path=":id/account-usage" element={<AccountUsageDetails />} />
          <Route path=":id/templates-used" element={<TemplatesUsed />} />
          <Route path="subscription-plans" element={<SubscriptionPlans />} />
          <Route path="configurations/contacts" element={<ContactsList />} />
          <Route
            path="configurations/contacts/:id/contact-detail"
            element={<ContactDetail />}
          />
          <Route path="add-response" element={<AddMessages />} />
          <Route path=":id/request-credits" element={<RequestCredits />} />
          <Route path="help-feedback" element={<HelpFeedbackForm />} />
          <Route path="wallet-recharge" element={<RechargeComponent />} />
          <Route path="grouped-templates" element={<GroupedTemplates />} />
          <Route path="upload-files" element={<VoiceFileUpload />} />
          <Route path="voice-files" element={<VoiceFilesList />} />
          <Route path="voice-reports" element={<ReportDashboard />} />
          <Route path="voice-history" element={<VoiceTransactonHistory />} />
          <Route path="rcs-usage-history" element={<UsageHistoryRcs />} />
          <Route path="all-voice-files" element={<AllVoiceFilesList />} />
          <Route path="voice-reports-view" element={<VoiceFullReports />} />
          <Route path=":id/voice-files" element={<VoiceFileDetails />} />
          <Route path="upload-contacts-csv" element={<UploadContactsForm />} />
          <Route path="voice-campaigns" element={<VoiceCampaigns />} />
          <Route
            path="launch-voice-campaign"
            element={<LaunchVoiceCampaign />}
          />
          <Route path="voice-campaign-reports" element={<ReportDashboard />} />
          <Route
            path="scheduled-voice-campaigns"
            element={<ScheduledCampaignsList />}
          />
          <Route path="live-voice-report" element={<LiveVoiceReport />} />
          <Route path="voice-download-reports" element={<DownloadReports />} />
          <Route path="reply-builder" element={<AutoReplyBuilder />} />
          <Route path="old-chatbots" element={<ChatbotList />} />
          <Route path="category-manager" element={<CategoryManager />} />
          <Route path="chatbots" element={<ChatbotFlowsList />} />
          <Route path=":id/edit-chatbot" element={<EditMessages />} />
          <Route
            path=":messageId/:cusId/message-debug-detail"
            element={<MessageDebugDetail />}
          />
          <Route path=":id/chatbot-detail" element={<ChatBotDetail />} />
          <Route path=":id/message-detail" element={<RdMessageDetail />} />
          <Route path="my-campaigns" element={<TrackMyCampaign />} />
          <Route path="chats" element={<Chats />} />
          <Route path="user-responses" element={<UserResponses />} />
          <Route path="database" element={<ContactDatabase />} />
          <Route
            path="account-link/:wabaId/:phoneId"
            element={<AccountLink />}
          />
          <Route path="textfield-testing" element={<TextFieldTest />} />
          <Route path="pricing-editor" element={<PricingEditor />} />
          <Route
            path="campaign-chats/:campaignName"
            element={<MyCampaignChats />}
          />
          <Route path="sheets-schema-design" element={<SheetSchemaBuilder />} />
          <Route path="sheet-schemas" element={<SheetSchemaList />} />
          <Route path="sheet-schemas/:id/edit" element={<SheetSchemaEdit />} />

          <Route path="manage-accounts" element={<ManageAccounts />} />
          <Route path="transaction-history" element={<TransactionHistory />} />
          <Route path="usage-history" element={<CreditUsageHistory />} />
          <Route path="accounts-list" element={<AccountsList />} />
          <Route path="manage-reseller" element={<ResellersList />} />
          <Route path="accounts/:id/edit-account" element={<EditAccount />} />
          <Route path="add-account" element={<AddAccount />} />
          <Route path="manage-plans" element={<PricingPlansManager />} />
          <Route
            path=":id/update-account-limit"
            element={<AccountSetLimit />}
          />
          <Route path="add-reseller" element={<AddReseller />} />
          <Route path=":id/edit-reseller" element={<AddReseller />} />
          <Route path="database-corner" element={<DatabaseManager />} />
          <Route path="add-item-form" element={<AddItemForm />} />
          <Route path="add-user-manually" element={<AddUserManually />} />
          <Route path=":id/account-details" element={<AccountDetails />} />
          <Route path=":id/users-list" element={<UsersList />} />
          <Route path=":id/add-user" element={<AddUser />} />
          <Route path="upload-audio" element={<UploadAudio />} />
          <Route path="prompt-previewer" element={<PromptPreviewer />} />
          <Route path="columns-manager" element={<DbColumnsManager />} />
          <Route path="media-library" element={<MediaLibrary />} />
          <Route path="media-type" element={<ExampleUsage />} />
          <Route path="flows" element={<FlowsList />} />
          <Route path="flows-reports" element={<FlowsReport />} />
          <Route path="new-dash" element={<MainDash />} />
          <Route path="number-quality-guide" element={<WabaQualityGuide />} />
          <Route path="rcs-dashboard" element={<RcsPanel />} />
          <Route path="rcs-campaign" element={<RcsCampaignLauncher />} />
          <Route path="rcs2-campaign" element={<Rcs2CampaignLauncher />} />
          <Route path="rcs-templates" element={<RcsTemplates />} />
          <Route path="rcs1-templates" element={<RcsJioTemplates />} />
          <Route path="rcs-add-template" element={<RcsAddTemplate />} />
          <Route path="rcs2-add-template" element={<RCSFormGenerator />} />
          <Route path="all-users-templates" element={<AdminRcsTemplates />} />
          <Route path="rcs-launch-campaign" element={<RcsCampaignBuilder />} />
          <Route path="flow-response/:id" element={<DataTableWithExport />} />
          <Route path="zoho-auths" element={<ZohoAuth />} />
          <Route path=":id/forms-flow-builder" element={<FlowForms />} />
          <Route path="chatbot-flows-list" element={<ChatbotFlowsList />} />
          <Route
            path=":id/chatbot-flow-details"
            element={<ChatbotFlowDetails />}
          />
          <Route
            path="manage-account-groups"
            element={<AccountGroupsManage />}
          />
          <Route path="voice-dashboard" element={<VoiceDashboard />} />
          <Route path="voice-fallback-reports" element={<VoiceFallback />} />
          <Route path=":id/assign-user" element={<AssignUser />} />
          <Route path="add-chatbot-flow" element={<AddChatbotFlow />} />
          <Route
            path="carousel-creator"
            element={<WhatsAppCarouselCreator />}
          />
          <Route
            path=":id/template-detail"
            element={<AdminRcsTemplateDetail />}
          />
          <Route path=":id/flow-details" element={<FlowDetails />} />
          <Route path=":id/flow-json-editor" element={<FlowJsonEditor />} />
          <Route path="create-raw-template" element={<TemplateCreatorRaw />} />
          <Route path="send-raw-message" element={<RawSendMessage />} />
          <Route path="create-flow" element={<CreateFlow />} />
          <Route path="campaign-agent-create" element={<CampaignAiTable />} />
          <Route path="json-pretty" element={<JsonPrettifier />} />
          <Route path="template-details/:id" element={<TemplateDetails />} />
          <Route
            path=":id/template-tracker"
            element={<TemplateStatusChecker />}
          />
          <Route path=":id/campaign-detail" element={<RdMyCampaignLive />} />
          <Route path=":id/sub-accounts" element={<SubAccountsList />} />
          <Route path=":id/campaign-report" element={<RdCampaignDetail />} />
          <Route path="edit-template" element={<CreateSubmitTemplate />} />
          <Route path="create-template" element={<CreateSubmitTemplate />} />
        </Routes>
      </Box>
      <ImageSelectionModal dialog={dialog} onClose={hideMediaDialog} />
      <CommonDialog dialog={dialog} onClose={hideDialog} />
      <CommonInputDialog dialog={dialog} onClose={hideInputDialog} />
      <CommonAiOptions dialog={dialog} onClose={hideAiDialog} />
    </>
  );
};

export default HomeDash;
